import { render, staticRenderFns } from "./DemandOrder.vue?vue&type=template&id=09613e79&scoped=true&"
import script from "./DemandOrder.vue?vue&type=script&lang=js&"
export * from "./DemandOrder.vue?vue&type=script&lang=js&"
import style0 from "./DemandOrder.vue?vue&type=style&index=0&id=09613e79&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09613e79",
  null
  
)

export default component.exports